import React, { useState } from "react";
import withAnimation from "../../../hooks/withAnimation";
import { send } from 'emailjs-com';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phoneNumber:'',
    message: ''
  });

  const [loading, setLoading] = useState(false);
  const [statusMessage, setStatusMessage] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const serviceID = 'service_obmmt4j';
    const templateID = 'template_d15n4m9';
    const userID = 'FAt-aBZnCiwVdXI20';

    send(serviceID, templateID, formData, userID)
      .then((response) => {
        setStatusMessage('Message sent successfully!');
      })
      .catch((err) => {
        console.log(err);
        
        setStatusMessage('Failed to send the message.',err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <section className="bg-background py-16">
      <div className="container mx-auto px-6 lg:px-20">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-primary">Get in Touch</h2>
          <p className="text-lg text-gray-600 mt-4">
            We'd love to hear from you. Please fill out the form or contact us
            using the details below.
          </p>
        </div>

        {/* Contact Form & Details */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Form */}
          <div className="bg-white p-8 rounded-lg shadow-lg">
            {statusMessage && (
              <p className={`mt-4 text-center ${statusMessage.includes('successfully') ? 'text-green-500' : 'text-red-500'}`}>
                {statusMessage}
              </p>
            )}
            <form className="space-y-6" onSubmit={handleSubmit}>
              <div>
                <label
                  htmlFor="name"
                  className="block text-lg font-semibold text-gray-700"
                >
                  Full Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full mt-2 px-4 py-3 border border-gray-300 rounded-lg focus:border-primary focus:ring-2 focus:ring-primary transition duration-200"
                  placeholder="Your Full Name"
                  required
                />
              </div>
              <div>
                <label
                  htmlFor="email"
                  className="block text-lg font-semibold text-gray-700"
                >
                  Email Address
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full mt-2 px-4 py-3 border border-gray-300 rounded-lg focus:border-primary focus:ring-2 focus:ring-primary transition duration-200"
                  placeholder="Your Email Address"
                  required
                />
              </div>
              <div>
                <label
                  htmlFor="phoneNumber"
                  className="block text-lg font-semibold text-gray-700"
                >
                  Phone Number
                </label>
                <input
                  
                  id="phoneNumber"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  className="w-full mt-2 px-4 py-3 border border-gray-300 rounded-lg focus:border-primary focus:ring-2 focus:ring-primary transition duration-200"
                  placeholder="Your Phone Number"
                  required
                />
              </div>
              <div>
                <label
                  htmlFor="message"
                  className="block text-lg font-semibold text-gray-700"
                >
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="6"
                  className="w-full mt-2 px-4 py-3 border border-gray-300 rounded-lg focus:border-primary focus:ring-2 focus:ring-primary transition duration-200"
                  placeholder="Your Message"
                  required
                ></textarea>
              </div>
              <button
                type="submit"
                className={`w-full bg-primary hover:bg-secondary text-white py-4 rounded-lg font-semibold transition duration-200 ${
                  loading ? "opacity-50 cursor-not-allowed" : ""
                }`}
                disabled={loading}
              >
                {loading ? "Sending..." : "Send Message"}
              </button>
            </form>
          </div>

          {/* Contact Details */}
          <div className="space-y-5 w-[90%]">
            <div className=" p-8 rounded-lg ">
              <h3 className="text-3xl font-bold text-black">Have Questions?</h3>
              <p className="text-lg text-gray-700 mt-8 text-justify">
                Call or email us to discover how our chiropractic, physiotherapy, massage therapy, or any of our many services can help you live your best life. Give us a call today!
              </p>
            </div>
            <div className=" p-8 rounded-lg ">
              <h3 className="text-3xl font-bold text-black">Conklin Health Centre in Ontario</h3>
              <p className="text-lg text-gray-700 mt-8 text-justify">
                Our 3,000 square foot Conklin Health Centre in Brantford, ON offers a huge variety of treatments and services including physiotherapy, chiropractic, massage therapy, and more.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default withAnimation(ContactSection);
